import * as types from "./ActionTypes";
import * as utilityApis from "../../apis/revshare/UtilitiesApi";
import { addActiveApiCall } from "./ActiveApiActions";

export function loadTodayInformationSuccess(today) {
  return { type: types.LOAD_TODAY_INFORMATION_SUCCESS, today };
}

export function loadActiveConsultantListSuccess(consultants) {
  return { type: types.LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS, consultants };
}

export function loadUtilizationRequestStatusesSuccess(statuses) {
  return { type: types.LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS, statuses };
}

export function loadHoursTransactionTypesSuccess(typeList) {
  return { type: types.LOAD_HOURS_TRANSACTION_TYPES_SUCCESS, typeList };
}

export function getBlackoutPeriodActiveSuccess(status) {
  return { type: types.GET_BLACKOUT_PERIOD_ACTIVE_SUCCESS, status };
}

export function toggleBlackoutPeriodSuccess(status) {
  return { type: types.TOGGLE_BLACKOUT_PERIOD_SUCCESS, status };
}

export function loadTodayInformation() {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.LOAD_TODAY_INFORMATION_SUCCESS));
    return utilityApis
      .getThisWeekInformation()
      .then((today) => {
        dispatch(loadTodayInformationSuccess(today));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function loadActiveConsultantList() {
  return function (dispatch) {
    //dispatch(addActiveApiCall(types.LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS));
    return utilityApis
      .getActiveConsultants()
      .then((consultants) => dispatch(loadActiveConsultantListSuccess(consultants)))
      .catch((error) => {
        throw error;
      });
  };
}

export function loadUtilizationRequestStatuses() {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS));
    return utilityApis
      .getUtilizationRequestStatuses()
      .then((statuses) => dispatch(loadUtilizationRequestStatusesSuccess(statuses)))
      .catch((error) => {
        throw error;
      });
  };
}

export function loadHoursTransactionTypes() {
  return function (dispatch) {
    dispatch(addActiveApiCall(types.LOAD_HOURS_TRANSACTION_TYPES_SUCCESS));
    return utilityApis
      .getHoursTransactionTypes()
      .then((typeList) => dispatch(loadHoursTransactionTypesSuccess(typeList)))
      .catch((error) => {
        throw error;
      });
  };
}

export function getBlackoutPeriodActive() {
  return function (dispatch) {
    return utilityApis
      .cashOutBlackoutIsActive()
      .then((status) => dispatch(getBlackoutPeriodActiveSuccess(status)))
      .catch((error) => {
        throw error;
      });
  };
}

export function toggleBlackoutPeriod() {
  return function (dispatch) {
    return utilityApis
      .flipCashOutBlackOut()
      .then((status) => dispatch(toggleBlackoutPeriodSuccess(status)))
      .catch((error) => {
        throw error;
      });
  };
}
